import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Layout } from "@/components/Layout";
import { getRecordatoriosEmpresas } from "@/lib/prevelis";
import { Building2, ChevronRight, Search, BellRing } from "lucide-react";

export default function Recordatorios() {
  const [empresas, setEmpresas] = useState([]);
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  useEffect(() => { getRecordatoriosEmpresas().then(setEmpresas).catch(() => {}); }, []);

  const filtradas = empresas.filter((e) =>
    (e.razon_social || "").toLowerCase().includes(q.toLowerCase()) ||
    (e.cif || "").toLowerCase().includes(q.toLowerCase())
  );

  return (
    <Layout title="Recordatorios" subtitle="Vencimientos de formación, EPIs, reconocimientos y revisiones por empresa y trabajador">
      <div className="relative max-w-md mb-6">
        <Search className="w-4 h-4 text-slate-400 absolute left-3 top-1/2 -translate-y-1/2" />
        <input
          data-testid="recordatorios-search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Buscar empresa…"
          className="w-full h-11 pl-9 pr-3 rounded-lg border border-slate-300 focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none"
        />
      </div>

      {filtradas.length === 0 ? (
        <div className="bg-white border border-dashed border-slate-300 rounded-xl p-12 text-center text-slate-500" data-testid="recordatorios-vacio">
          {empresas.length === 0
            ? "Aún no hay empresas. Crea una empresa para empezar a registrar vencimientos."
            : "Ninguna empresa coincide con la búsqueda."}
        </div>
      ) : (
        <div className="space-y-3" data-testid="recordatorios-empresas">
          {filtradas.map((e) => (
            <button
              key={e.id}
              data-testid={`recordatorio-empresa-${e.id}`}
              onClick={() => navigate(`/recordatorios/${e.id}`)}
              className="w-full text-left bg-white border border-slate-200 rounded-xl p-5 hover:border-blue-300 transition-colors flex items-center gap-4"
            >
              <div className="w-11 h-11 rounded-lg bg-blue-50 text-blue-700 flex items-center justify-center shrink-0">
                <Building2 className="w-5 h-5" />
              </div>
              <div className="min-w-0 flex-1">
                <div className="font-heading font-semibold text-slate-900 truncate">{e.razon_social}</div>
                <div className="text-xs text-slate-500">{e.cif || "—"}</div>
              </div>
              <div className="flex items-center gap-2 shrink-0">
                {e.vencidos > 0 && (
                  <span className="text-xs font-medium px-2.5 py-1 rounded-full border bg-red-50 text-red-700 border-red-200">
                    {e.vencidos} vencido{e.vencidos === 1 ? "" : "s"}
                  </span>
                )}
                {e.proximos > 0 && (
                  <span className="text-xs font-medium px-2.5 py-1 rounded-full border bg-amber-50 text-amber-700 border-amber-200">
                    {e.proximos} próximo{e.proximos === 1 ? "" : "s"}
                  </span>
                )}
                <span className="text-xs font-medium px-2.5 py-1 rounded-full border bg-slate-100 text-slate-600 border-slate-200 inline-flex items-center gap-1">
                  <BellRing className="w-3.5 h-3.5" /> {e.total}
                </span>
              </div>
              <ChevronRight className="w-5 h-5 text-slate-400 shrink-0" />
            </button>
          ))}
        </div>
      )}
    </Layout>
  );
}
